import { create } from 'zustand';

import { StoryAgeGrade } from '@constants';
import { IEpisodeDetail, IPagination, IStory } from '@model';

type ReadStoryStore = {
  data?: {
    storyId: number;
    episodeId: number;
    readEpisodeCount: number;
    tapCount: number;
    startReadDatetime: string;
    isLastEpisodeRead: boolean;
    endReadDatetime: string;
    ageGrade: StoryAgeGrade;
  };
  selectedIds: number[];
  readStoryIds: number[];
  read: (episode: IEpisodeDetail) => void;
  tap: () => void;
  tick: () => void;
  reset: () => void;
  deselectAll: () => void;
  selectAll: () => void;
  select: (id: number) => void;
  cancelSelect: (id: number) => void;
  setReadStoryIds: (readStoryPages: IPagination<IStory>[]) => void;
};

export const useReadStoryStore = create<ReadStoryStore>((set, get) => ({
  data: undefined,
  selectedIds: [],
  readStoryIds: [],
  read: (episode) => {
    const { data } = get();
    if (!data) {
      set({
        data: {
          storyId: episode.story.id,
          episodeId: episode.id,
          readEpisodeCount: 1,
          tapCount: 0,
          startReadDatetime: new Date().toISOString(),
          endReadDatetime: new Date().toISOString(),
          isLastEpisodeRead: !episode.nextEpisode,
          ageGrade: episode.story.ageGrade,
        },
      });
    } else {
      set({
        data: {
          ...data,
          episodeId: episode.id,
          readEpisodeCount: data.readEpisodeCount + 1,
          endReadDatetime: new Date().toISOString(),
          isLastEpisodeRead: !episode.nextEpisode,
          ageGrade: episode.story.ageGrade,
        },
      });
    }
  },
  tap: () => {
    const { data } = get();
    if (!data) {
      return;
    }

    set({
      data: {
        ...data,
        tapCount: data.tapCount + 1,
      },
    });
  },
  tick: () => {
    const { data } = get();
    if (!data) {
      return;
    }

    set({
      data: {
        ...data,
        endReadDatetime: new Date().toISOString(),
      },
    });
  },
  reset: () => {
    set({ data: undefined });
  },
  select: (id: number) => {
    const { selectedIds } = get();
    set({
      selectedIds: [...selectedIds, id],
    });
  },
  cancelSelect: (id: number) => {
    const { selectedIds } = get();

    const updatedSelectedIds = selectedIds.filter((itemId) => itemId !== id);
    set({
      selectedIds: updatedSelectedIds,
    });
  },
  deselectAll: () => {
    set({
      selectedIds: [],
    });
  },
  selectAll: () => {
    const { readStoryIds } = get();

    set({
      selectedIds: readStoryIds,
    });
  },
  setReadStoryIds: (readStoryPages: IPagination<IStory>[]) => {
    const readStoryIds = readStoryPages.flatMap((page) =>
      page.items.map((item) => item.id)
    );

    set({
      readStoryIds: readStoryIds,
    });
  },
}));
